import { HierarchyUtils, ComponentIds, Vector, Size, } from "@inter-ikea-core/core";
/**
 * Tries to find the dimensions of a room using either RoomGeometryComponent or
 * RoomDimensionsComponent. It will use the result from the first one it finds, if any.
 *
 * @param roots entities that are returned from serialization
 * @returns the dimensions of the room if it is found, otherwise null
 */
export function getRoomDimensionsFromLegacyComponents(roots) {
    for (var i = 0; i < roots.length; i++) {
        var root = roots[i];
        var roomWithGeometry = HierarchyUtils.getEntityAndComponentForDescendantWithComponent(root, ComponentIds.ROOM_GEOMETRY_COMPONENT_ID);
        if (roomWithGeometry) {
            var dimensions = roomWithGeometry.component.dimensions;
            return {
                size: new Size(dimensions.size.X, dimensions.size.Y, dimensions.size.Z),
                center: dimensions.center,
            };
        }
        var roomWithDimensions = HierarchyUtils.getEntityAndComponentForDescendantWithComponent(root, ComponentIds.ROOM_DIMENSIONS_COMPONENT_ID);
        if (roomWithDimensions) {
            // At the time when RoomDimensionsComponent was used, origo was placed
            // at the back wall. This is why the Z-coordinate of the center looks
            // like it does.
            var dimensions = roomWithDimensions.component.dimensions;
            return {
                size: new Size(dimensions.X, dimensions.Y, dimensions.Z),
                center: new Vector(0, dimensions.Y / 2, dimensions.Z / 2),
            };
        }
    }
    return null;
}
/**
 * Returns all entities that are direct children of the room or that are non-room children
 * of the scene. It's meant to be used on the roots that are returned from deserialization.
 * It assumes that the room is marked with a `RoomComponent`.
 * This function has support for multi-entity rooms (where walls, windows, doors, etc.
 * are separate entities).
 *
 * @param roots entities returned from serialization
 * @returns all entities that are direct children of the room
 */
export function getChildrenOfRoomAndScene(roots) {
    return roots.flatMap(function (root) {
        var room = findRoom(root);
        if (!room) {
            return [root];
        }
        else {
            var newRoots = [];
            var scene = HierarchyUtils.parent(room);
            if (scene) {
                var nonRoomChildren = HierarchyUtils.children(scene).filter(function (child) {
                    return !child.hasComponent(ComponentIds.ROOM_COMPONENT_ID);
                });
                newRoots.push.apply(newRoots, nonRoomChildren);
            }
            var roomDescendants = findAllNonRoomPartDescendants(room);
            newRoots.push.apply(newRoots, roomDescendants);
            return newRoots;
        }
    });
}
function findRoom(scene) {
    return HierarchyUtils.getDescendantWithComponent(scene, ComponentIds.ROOM_COMPONENT_ID);
}
function isRoomEntity(entity) {
    return (entity.hasComponent(ComponentIds.ROOM_PART_COMPONENT_ID) ||
        entity.hasComponent(ComponentIds.ROOM_COMPONENT_ID));
}
function findAllNonRoomPartDescendants(roomPart) {
    if (isRoomEntity(roomPart)) {
        return HierarchyUtils.children(roomPart).flatMap(function (child) {
            return findAllNonRoomPartDescendants(child);
        });
    }
    else {
        return [roomPart];
    }
}
//# sourceMappingURL=RoomHierarchyUtils.js.map